import dayjs from 'dayjs';

export const FULL_DATETIME_FORMAT = 'DD/MM/YYYY - dddd HH:mm';

export const parseDateTime = (date:string, time: string) => {
  const [hour, minute] = time?.split(':') || [0, 0];

  return dayjs(date, 'DD/MM/YYYY').hour(Number(hour)).minute(Number(minute)).format(FULL_DATETIME_FORMAT);
};

export const toApiDate = (date:string, time: string) => {
  const [hour, minute] = time?.split(':') || [0, 0];

  return dayjs(date, 'DD/MM/YYYY').hour(Number(hour)).minute(Number(minute)).toJSON();
};
